import React from "react";
import PropTypes from "prop-types";
import i18n from "i18next";
import { RATIO_PRESETS } from "../../../../core/editor/ratio_presets";
import "./RatioPicker.scss";

export default function RatioPicker({ selectedKey, onChange, disabled }) {
  return (
    <div className="ratio-picker">
      {RATIO_PRESETS.map((p) => {
        const isSelected = p.key === selectedKey;
        return (
          <button
            key={p.key}
            type="button"
            className={`ratio-picker__btn ${isSelected ? "ratio-picker__btn--selected" : ""}`}
            aria-pressed={isSelected}
            disabled={disabled}
            onClick={() => onChange(p.key)}
          >
            <span className="ratio-picker__label">{p.label}</span>
            <span className="ratio-picker__style">{i18n.t(p.styleKey)}</span>
          </button>
        );
      })}
    </div>
  );
}

RatioPicker.propTypes = {
  selectedKey: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

RatioPicker.defaultProps = {
  selectedKey: null,
  disabled: false,
};
